import React from 'react';
import type { IconProps } from '../types';

export const EmptyBox = (props: IconProps) => (
  <svg
    width="218"
    height="218"
    viewBox="0 0 218 218"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="icon-empty-box"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M177.125 121.32H40.8748V184.377C40.8748 187.385 42.847 190.038 45.7287 190.903C59.4184 195.008 97.9158 206.558 107.041 209.297C108.319 209.678 109.681 209.678 110.958 209.297C120.084 206.558 158.581 195.008 172.271 190.903C175.153 190.038 177.125 187.385 177.125 184.377C177.125 168.585 177.125 121.32 177.125 121.32Z"
        fill="#312E81"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M177.125 121.32H109C109 121.32 108.339 209.583 109 209.583C109.661 209.583 110.318 209.488 110.959 209.297C120.084 206.558 158.581 195.008 172.271 190.903C175.153 190.038 177.125 187.385 177.125 184.377C177.125 168.585 177.125 121.32 177.125 121.32Z"
        fill="#A4BBDB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109 143.423L40.8748 121.32C40.8748 121.32 28.929 139.033 23.588 146.949C22.9885 147.838 22.8421 148.952 23.1895 149.963C23.5404 150.975 24.3408 151.762 25.3593 152.096C38.2996 156.299 76.6063 168.746 86.6548 172.009C88.0956 172.479 89.6761 171.937 90.5277 170.68C95.0955 163.939 109 143.423 109 143.423Z"
        fill="#E9F3FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M177.125 121.32L109 143.423C109 143.423 122.904 163.939 127.472 170.68C128.323 171.937 129.904 172.479 131.345 172.009C141.393 168.746 179.7 156.299 192.64 152.096C193.659 151.762 194.459 150.975 194.81 149.963C195.157 148.952 195.011 147.838 194.411 146.949C189.07 139.033 177.125 121.32 177.125 121.32Z"
        fill="#E9F3FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.5103 74.8898C91.6588 73.6397 90.0817 73.0982 88.6408 73.5682C78.5992 76.828 40.2823 89.2778 27.342 93.4846C26.3235 93.815 25.5196 94.6018 25.1722 95.6135C24.8247 96.6251 24.9712 97.7424 25.5707 98.628C30.4893 105.924 40.875 121.32 40.875 121.32L109 99.1423C109 99.1423 96.7647 81.1471 92.5103 74.8898Z"
        fill="#312E81"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M192.429 98.628C193.029 97.7424 193.175 96.6251 192.828 95.6135C192.48 94.6018 191.676 93.815 190.658 93.4846C177.717 89.2778 139.401 76.828 129.359 73.5682C127.918 73.0982 126.341 73.6397 125.489 74.8898C121.235 81.1471 109 99.1423 109 99.1423L177.125 121.32C177.125 121.32 187.51 105.924 192.429 98.628Z"
        fill="#E9F3FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M177.125 121.32L109 99.1421L40.8748 121.32L109 143.423L177.125 121.32Z"
        fill="#312E81"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109 143.423V99.1421L40.8748 121.32L109 143.423Z"
        fill="#A4BBDB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M95.3131 108.925C93.8961 107.998 92.6188 107.007 91.4845 105.968C90.1016 104.698 87.9454 104.79 86.6715 106.176C85.401 107.559 85.4929 109.715 86.8793 110.986C88.2724 112.267 89.8427 113.486 91.5867 114.627C93.1604 115.656 95.2723 115.213 96.301 113.639C97.3296 112.066 96.8868 109.954 95.3131 108.925Z"
        fill="#D8B4FE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.6995 98.4611C83.6879 97.0884 82.8329 95.7089 82.1312 94.3294C81.2797 92.6535 79.2257 91.9858 77.5498 92.8374C75.8739 93.689 75.2063 95.7429 76.0579 97.4188C76.9231 99.1151 77.9722 100.815 79.2155 102.501C80.3293 104.013 82.4616 104.337 83.9774 103.223C85.4898 102.106 85.8134 99.9735 84.6995 98.4611Z"
        fill="#D8B4FE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.7195 84.5603C79.7535 83.1876 79.9545 81.8558 80.3224 80.5784C80.8401 78.7731 79.7944 76.8827 77.9857 76.3649C76.1804 75.8472 74.2899 76.8929 73.7722 78.7016C73.251 80.5273 72.9581 82.4314 72.907 84.39C72.8627 86.2703 74.3478 87.8337 76.2281 87.878C78.1083 87.9257 79.6718 86.4406 79.7195 84.5603Z"
        fill="#D8B4FE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.9582 73.1834C85.8336 72.3727 86.8146 71.6233 87.8875 70.9455C89.4783 69.9407 89.9551 67.8356 88.9537 66.2483C87.9488 64.6576 85.8438 64.1807 84.2531 65.1821C82.8122 66.0916 81.5042 67.0964 80.3291 68.1864C78.9495 69.4638 78.8678 71.6199 80.1451 72.9995C81.4225 74.379 83.5786 74.4608 84.9582 73.1834Z"
        fill="#D8B4FE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.6262 67.3076C99.3396 66.9908 101.155 66.7864 103.069 66.7081C104.95 66.6264 106.408 65.0356 106.329 63.1588C106.251 61.2819 104.66 59.8207 102.78 59.899C100.532 59.9944 98.3994 60.2362 96.3864 60.6075C94.5402 60.9515 93.3139 62.7296 93.6579 64.5758C93.9986 66.4254 95.7766 67.6482 97.6262 67.3076Z"
        fill="#D8B4FE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.38 67.1065C118.285 67.1405 120.99 67.0383 123.5 66.8169C125.374 66.65 126.76 64.9946 126.593 63.1212C126.426 61.2511 124.771 59.8648 122.897 60.0317C120.598 60.2327 118.122 60.328 115.458 60.294C113.578 60.2735 112.035 61.7825 112.014 63.6593C111.99 65.5396 113.499 67.086 115.38 67.1065Z"
        fill="#D8B4FE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M134.697 64.7291C138.069 63.697 140.916 62.3754 143.301 60.8596C144.885 59.848 145.355 57.7429 144.343 56.1556C143.335 54.5717 141.226 54.1016 139.639 55.1133C137.721 56.3327 135.422 57.3818 132.704 58.213C130.909 58.7648 129.894 60.6689 130.446 62.4674C130.994 64.2659 132.901 65.2775 134.697 64.7291Z"
        fill="#D8B4FE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M152.034 51.3252C153.642 48.0007 154.259 44.4854 154.102 41.0962C154.013 39.216 152.416 37.7649 150.539 37.8535C148.662 37.942 147.208 39.5361 147.296 41.413C147.405 43.7156 146.99 46.1034 145.9 48.3617C145.082 50.0546 145.791 52.095 147.484 52.9125C149.177 53.73 151.217 53.0181 152.034 51.3252Z"
        fill="#D8B4FE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M149.865 29.0519C147.382 25.6967 144.013 23.36 140.341 22.6072C138.498 22.2325 136.696 23.4179 136.318 25.2607C135.943 27.1035 137.132 28.9054 138.971 29.2835C141.09 29.7161 142.957 31.1705 144.391 33.1087C145.511 34.6177 147.647 34.9344 149.156 33.8172C150.669 32.6965 150.985 30.5608 149.865 29.0519Z"
        fill="#D8B4FE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.365 23.2682C109.051 2.39806 140.991 3.74693 122.396 23.2682H105.365Z"
        fill="#E9D5FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.365 28.5547C109.051 49.4214 140.991 48.0759 122.396 28.5547H105.365Z"
        fill="#E9D5FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.059 29.3516H127.867C129.747 29.3516 131.273 27.8256 131.273 25.9453C131.273 24.0651 129.747 22.5391 127.867 22.5391H105.059C103.182 22.5391 101.653 24.0651 101.653 25.9453C101.653 27.8256 103.182 29.3516 105.059 29.3516Z"
        fill="#D8B4FE"
      />
    </g>
  </svg>
);

export default EmptyBox;
